import axios from '@axios'

const buildRequestParams = queryParams => {
  const params = {}

  Object.keys(queryParams || {}).forEach(key => {
    const value = queryParams[key]

    if (value !== null && typeof value !== 'undefined' && value !== '') {
      params[key] = value
    }
  })

  return params
}

export default {
  namespaced: true,

  state: {
    feedback: {},
    submitting: false,
  },

  getters: {
    feedback: state => state.feedback,
    submitting: state => state.submitting,
  },

  mutations: {
    setFeedback(state, feedback) {
      state.feedback = feedback || {}
    },

    unsetFeedback(state) {
      state.feedback = {}
    },

    setSubmitting(state, value) {
      state.submitting = value
    },
  },

  actions: {
    async fetchFeedbacks(ctx, queryParams = {}) {
      return axios.get('/feedbacks', {
        params: buildRequestParams(queryParams),
      })
    },

    async fetchFeedbacksSummary(ctx, queryParams = {}) {
      return axios.get('/feedbacks/summary', {
        params: buildRequestParams(queryParams),
      })
    },

    async fetchFeedback(ctx, { id }) {
      const response = await axios.get(`/feedbacks/${id}`)
      const successStatuses = [200, 201]

      if (successStatuses.includes(response.status)) {
        ctx.commit('setFeedback', response.data.data || {})
      }

      return response
    },

    async createFeedback(ctx, { eventId, payload }) {
      ctx.commit('setSubmitting', true)

      try {
        const response = await axios.post(`/events/${eventId}/feedback`, payload)
        const successStatuses = [200, 201]

        if (successStatuses.includes(response.status)) {
          ctx.commit('setFeedback', response.data.data || {})
        }

        return response
      } finally {
        ctx.commit('setSubmitting', false)
      }
    },
  },
}